import { c as _c } from "react/compiler-runtime";
// apiService.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "./axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { dayJsDate } from "@/utils/common";
import { toast } from "react-toastify";
const getAppointment = async (userId, repId = null, page, date) => {
  console.log(userId, 'fetchDataById');
  let queryString = '';
  if (page) {
    queryString = `page=${page}&`;
  }
  if (date) {
    queryString += `date=${date}&`;
  }
  if (repId) {
    queryString += `repId=${repId}`;
  }
  if (userId) {
    const response = await axiosInstance.get(`/appointments/appointments-list/${userId}?${queryString}`);
    return response.data;
  } else {
    return null;
  }
};
const getAppointmentForDashboard = async (userId, page) => {
  console.log(userId, 'fetchDataById');
  let queryString = '';
  if (page) {
    queryString = `page=${page}&`;
  }
  const response = await axiosInstance.get(`/appointments/appointments-list-for-report/${userId}?${queryString}`);
  return response.data;
};
const cancelAppointmentApi = async id => {
  console.log(id, 'cancelAppointmentApi');
  const response = await axiosInstance.post(`/appointments/cancel-appointment/${id}`);
  return response.data;
};
const approveAppointmentApi = async id => {
  console.log(id, 'cancelAppointmentApi');
  const response = await axiosInstance.post(`/appointments/approve-appointment/${id}`);
  return response.data;
};
const approveRescheduledAppointmentApi = async id => {
  const response = await axiosInstance.post(`/appointments/approve-reschedule-appointment/${id}`);
  return response.data;
};
const rescheduleAppointmentApi = async data => {
  console.log(data, 'rescheduleAppointmentApi');
  const response = await axiosInstance.post(`/appointments/reschedule-appointment/${data.id}`, data);
  return response.data;
};
const useAppointments = t0 => {
  const $ = _c(46);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    repId: t2,
    userId: t3,
    currentDate: t4,
    page: pageNum
  } = t1;
  const repId = t2 === undefined ? null : t2;
  let userId = t3 === undefined ? null : t3;
  const currentDate = t4 === undefined ? "" : t4;
  useQueryClient();
  useDispatch();
  const [page, setPage] = useState(pageNum);
  const [date, setDate] = useState(currentDate);
  const storeUser = useSelector(_temp);
  userId = userId || storeUser?._id;
  let t5;
  if ($[2] !== date || $[3] !== page || $[4] !== userId) {
    t5 = ["appointments", userId, page, date];
    $[2] = date;
    $[3] = page;
    $[4] = userId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== date || $[7] !== page || $[8] !== repId || $[9] !== userId) {
    t6 = () => getAppointment(userId, repId, page, date);
    $[6] = date;
    $[7] = page;
    $[8] = repId;
    $[9] = userId;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = userId != null && (!!page || !!date);
  let t8;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const appointments = useQuery(t8);
  let t10;
  let t9;
  if ($[15] !== page || $[16] !== userId) {
    t9 = ["appointments", userId, page];
    t10 = () => getAppointmentForDashboard(userId, page);
    $[15] = page;
    $[16] = userId;
    $[17] = t10;
    $[18] = t9;
  } else {
    t10 = $[17];
    t9 = $[18];
  }
  const t11 = userId != null && !!page;
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t9) {
    t12 = {
      queryKey: t9,
      queryFn: t10,
      enabled: t11
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const appointmentForDashboard = useQuery(t12);
  let t13;
  if ($[23] !== appointments) {
    t13 = {
      mutationFn: cancelAppointmentApi,
      onSuccess: _temp2,
      onError: _temp3,
      onSettled: () => {
        appointments.refetch();
      }
    };
    $[23] = appointments;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const cancelAppointment = useMutation(t13);
  let t14;
  if ($[25] !== appointments) {
    t14 = {
      mutationFn: approveAppointmentApi,
      onSuccess: _temp4,
      onError: _temp5,
      onSettled: () => {
        appointments.refetch();
      }
    };
    $[25] = appointments;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const approveAppointment = useMutation(t14);
  let t15;
  if ($[27] !== appointments) {
    t15 = {
      mutationFn: approveRescheduledAppointmentApi,
      onSuccess: _temp6,
      onError: _temp7,
      onSettled: () => {
        appointments.refetch();
      }
    };
    $[27] = appointments;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const approveRescheduledAppointment = useMutation(t15);
  let t16;
  if ($[29] !== appointments) {
    t16 = data_3 => {
      if (data_3.status) {
        appointments.refetch();
        toast.success(data_3.message);
      }
    };
    $[29] = appointments;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== appointments) {
    t17 = () => {
      appointments.refetch();
    };
    $[31] = appointments;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = {
      mutationFn: rescheduleAppointmentApi,
      onSuccess: t16,
      onError: _temp8,
      onSettled: t17
    };
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const rescheduleAppointmentMutation = useMutation(t18);
  let t19;
  if ($[36] !== appointmentForDashboard || $[37] !== appointments || $[38] !== approveAppointment || $[39] !== approveRescheduledAppointment || $[40] !== cancelAppointment || $[41] !== page || $[42] !== rescheduleAppointmentMutation || $[43] !== setDate || $[44] !== setPage) {
    t19 = {
      appointments,
      cancelAppointment,
      rescheduleAppointmentMutation,
      approveRescheduledAppointment,
      appointmentForDashboard,
      approveAppointment,
      page,
      setPage,
      setDate
    };
    $[36] = appointmentForDashboard;
    $[37] = appointments;
    $[38] = approveAppointment;
    $[39] = approveRescheduledAppointment;
    $[40] = cancelAppointment;
    $[41] = page;
    $[42] = rescheduleAppointmentMutation;
    $[43] = setDate;
    $[44] = setPage;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};
export default useAppointments;
function _temp(state) {
  return state?.userData?.userData?.user;
}
function _temp2(data) {
  if (data.status) {
    toast.success(data.message);
  }
}
function _temp3() {
  toast.error(data.message);
}
function _temp4(data_0) {
  if (data_0.status) {
    toast.success(data_0.message);
  }
}
function _temp5() {
  toast.error(data.message);
}
function _temp6(data_1) {
  if (data_1.status) {
    toast.success(data_1.message);
  }
}
function _temp7(data_2) {
  toast.error(data_2?.message || "Something went wrong");
}
function _temp8(data_4) {
  toast.error(data_4.response.data?.message);
}